import request from '../../utils/request'

const medicalLiability = (id) => {
  return request({
      url:process.env.VUE_APP_API + `medical-liability/hospital/${id}`,
      method: 'GET',
  })
}


export {
  medicalLiability
}